// extracted by mini-css-extract-plugin
export default {"Faq":"Faq_Faq__tkoio","Faq__question":"Faq_Faq__question__Np6GO"};